import { format } from "date-fns";

import type { useTranslation } from "react-i18next";

export const getDatetimeDisplay = (
  datetime: number,
  t: ReturnType<typeof useTranslation>["t"]
) => {
  const targetDatetime = new Date(datetime);
  const dateDisplay = format(targetDatetime, "M/d");
  const dayDisplay = t(
    `common.string.dayOfWeek.${format(targetDatetime, "E")}`
  );
  const timeDisplay = format(targetDatetime, "HH:mm");
  const dateForTimeAttribute = format(targetDatetime, "y-MM-dd");

  return {
    dateDisplay,
    dateForTimeAttribute,
    dayDisplay,
    timeDisplay,
  };
};
